import script from "./TodoItems.vue?vue&type=script&setup=true&lang=js"
export * from "./TodoItems.vue?vue&type=script&setup=true&lang=js"

import "./TodoItems.vue?vue&type=style&index=0&id=c11b3a6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c11b3a6c"]])

export default __exports__